import { colors, LOADING_SPINNER_CLASS } from '@noths/polaris-client-ribbons-design-system';
import { inset, pxToRem, responsiveFontSize, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text, fonts } = theme;

export const ctaButton = css`
  padding: ${inset(spacing.md)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveFontSize(text.sm)};
  background-color: ${colors.brandBluePrimary};

  display: block;
  width: 100%;
  color: ${colors.neutralWhite};
  border: none;
  border-radius: 0.25rem;

  .${LOADING_SPINNER_CLASS} {
    width: ${pxToRem(text.sm.SMALL.lineHeight)};
  }
`;
